import { render, staticRenderFns } from "./NavNotificationsItem.vue?vue&type=template&id=3f289778&lang=pug"
import script from "./NavNotificationsItem.vue?vue&type=script&lang=js"
export * from "./NavNotificationsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports